// Helpers for linking from a media item's tags/people fields back to a filtered media-list view.

// Route segment used by /media-list/:mediaType for a given item. ScreenMedia is a single backend
// type but the list routes split it into TV/Movie (see MEDIA_TYPE_MAPPING in media_routes.py), so
// it needs to resolve via media_format instead of using item.type directly.
export const getMediaListType = (mediaItem) => {
  if (mediaItem?.type === 'ScreenMedia') {
    return mediaItem.media_format?.toLowerCase() === 'movie' ? 'Movie' : 'TV';
  }
  return mediaItem?.type;
};

// Link to the media-list's genre/tag/studio/meta-tag filter (`genre_tag`), pre-applied to one
// value. Lower-cased to match how filterEngine.js's getItemTagValues/itemMatchesFilter compare it.
export const genreTagListLink = (mediaListType, value) => {
  const params = new URLSearchParams();
  params.set('genre_tag', String(value).toLowerCase());
  return `/media-list/${mediaListType}#${params.toString()}`;
};

// Link to the media-list's free-text search box, pre-filled with one value (e.g. a studio,
// publisher, developer, author, artist or cast member name).
export const searchListLink = (mediaListType, value) => {
  const params = new URLSearchParams();
  params.set('search', value);
  return `/media-list/${mediaListType}#${params.toString()}`;
};

// Splits a comma-separated field (e.g. "MAPPA, Studio Trigger") into trimmed, non-empty parts.
export const splitCommaField = (raw) => {
  if (!raw) return [];
  return String(raw).split(',').map((v) => v.trim()).filter(Boolean);
};

// mediaType route segments (MediaListPage's :mediaType param) that span MULTIPLE local ranking
// lists at once (e.g. PhysicalGame combines every platform, Music combines vinyl+cd, Literature/
// ShowsAndMovies combine their sub-types). Media cards shown in one of these contexts should
// display the GLOBAL rank (globe icon) instead of the local rank, since "local rank" is ambiguous
// when items from several different local lists are mixed together on the same page.
export const GLOBAL_RANK_CONTEXTS = ['PhysicalGame', 'Music', 'Literature', 'ShowsAndMovies', 'All'];

export const isGlobalRankContext = (mediaType) => GLOBAL_RANK_CONTEXTS.includes(mediaType);
